export default {
  title: 'Crear en equipo',
  description: 'Invita a los colaboradores que participarán en la creación de este contenido y asigna el tipo de acceso deseado: editor o comentador.',
  invite: 'Invitar colaboradores',
  kreaPermissions: {
    none: 'Quitar acceso',
    comment: 'Comentador',
    edit: 'Editor',
    owner: 'Propietario'
  }
}

export const en = {
  title: 'Create in team',
  description: 'Invite collaborators who will participate in creating this content and assign the desired access type: editor or commenter.',
  invite: 'Invite collaborators',
  kreaPermissions: {
    none: 'Remove access',
    comment: 'Commenter',
    edit: 'Editor',
    owner: 'Owner'
  }
}

export const ca = {
  title: 'Crear en equip',
  description: 'Convida els col·laboradors que participaran en la creació d\'aquest contingut i assigna el tipus d\'accés desitjat: editor o comentador.',
  invite: 'Convidar col·laboradors',
  kreaPermissions: {
    none: 'Treure accés',
    comment: 'Comentador',
    edit: 'Editor',
    owner: 'Propietari'
  }
}
